export const PACKAGE_NAME = 'jiraIssueTableGroupByDropdown';
export const TEAM_NAME = 'jira-yurree';

export const GROUP_BY_DROPDOWN_EXPERIENCE = 'loadGroupByOptions';
export const ANALYTICS_SOURCE = 'jira-native-issue-table' as const;

export const ONBOARDING_TARGET_NAME = 'issue-navigator-group-by-dropdown';
export const GROUP_BY_DROPDOWN_CHANGED_EXPERIENCE = 'changeGroupByField';
